import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    meta: { title: '游戏中心' },
    component: () => import('@/views/Home.vue')
  },
  {
    path: '/home',
    name: 'home-alias',
    meta: { title: '游戏中心' },
    component: () => import('@/views/Home.vue')
  },
  {
    path: '/red-blue',
    name: 'red-blue-combat',
    meta: { title: '红蓝对抗' },
    component: () => import('@/views/RedBlueCombat.vue')
  },
  {
    path: '/schulte',
    name: 'schulte-grid',
    meta: { title: '舒尔特方格' },
    component: () => import('@/views/SchulteGrid.vue')
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
